<div class="scroll">
  <div class="content">

    <div class="hero container">
      <div class="column is-8 is-offset-2">
        <div class="container has-text-centered">
          <img src="assets/caddie_logo.png" alt="CADDIE logo" title="CADDIE logo" />
          <h2 class="subtitle is-3"> Cancer Driver Drug Interaction Explorer </h2>
        </div>
        <div class="content">
          <h2>Citation</h2>
          <p>
            If you use CADDIE in your work, please cite the following article:
          </p>

          <p>
            <i class="fa fa-feather"></i> URL:
            <a href="https://doi.org/10.1093/nar/gkac384" target="_blank"
              >https://doi.org/10.1093/nar/gkac384</a
            >
          </p>
          <p>
            Michael Hartung, Elisa Anastasi, Zeinab M Mamdouh, Cristian Nogales,
            Harald H H W Schmidt, Jan Baumbach, Olga Zolotareva, Markus List,
            Cancer driver drug interaction explorer, Nucleic Acids Research,
            2022;, gkac384, https://doi.org/10.1093/nar/gkac384
          </p>
          <h2>Source code</h2>
          <p>
            The source code is available here: <a href="https://github.com/biomedbigdata">https://github.com/biomedbigdata</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>



